const regexp = /^([^\/\\]+:)?(\/\/([^\/:]+):?([\d]+)?)?(\/[^\?#]*)?(\?[^#]*)?(#!?([^\?]+)?(\?.*)?)?/;

export class URL {

  protocol: string;
  hostname: string;
  port: string;
  pathname: string;
  search: string;
  hash: string;
  hashPath: string;
  hashSearch: string;

  constructor(url: string, base?: boolean | string | URL | Location) {
		let result = regexp.exec(url) || [];		

    if (base === true || typeof(base) === 'undefined') {
      base = window.location;
    }
    else if (typeof(base) === 'string') {
      base = new URL(base);
    }

		if (base) {	
			this.protocol = result[1] || base.protocol;
			this.hostname = result[3] || base.hostname;
			this.port = result[4] || base.port || '';
			this.pathname = result[5] || base.pathname;
		} else {
			this.protocol = result[1] || '';
			this.hostname = result[3] || '';
			this.port = result[4] || '';
			this.pathname = result[5] || '';
		}
		this.search = result[6] || '';
		this.hash = result[7] || '';
		this.hashPath = result[8] || ''; 
		this.hashSearch = result[9] || '';

		// shebang-support (#! for robots indexing ajax-urls)
		this.hash = this.hash.replace(/^#!/, '#');
	}
}